import client from '../httpClient';

const webResGetResponsesApi = (responseId) => {
  return client.get(`/responses/${responseId}`);
};

export default webResGetResponsesApi;
